import { IAction, IUserState } from 'src/interface';
import { Reducer } from 'redux';
import { ACTIONS } from '../../actions/user/dispatchActions';
import { handleReducer } from '../index';
import handler from './handler';

const defaultState: IUserState = {
    bookmark: [],
    follow: {
        publishers: [],
        topics: [],
        clusters: [],
    },
    like: [],
};

const userAssetReducer: Reducer<IUserState, IAction<ACTIONS>> = (
    state = defaultState,
    action: IAction<any>
) => {
    return handleReducer(handler, state, action);
};

export default userAssetReducer;
